import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import MobileDetailsOverlap from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Overlap';
import { StudioContext } from '@home/pages/studio/context';
import StudioState from '@home/pages/studio/components/StudioState';
import './index.scss';

interface IMobileOverlapServiceProps {
  className?: string;
  style?: React.CSSProperties;
}

const MobileOverlapService: React.FC<IMobileOverlapServiceProps> = ({
  className,
  style,
}) => {
  const { currentGame } = useContext(StudioContext);
  const gameId = currentGame?.unified_edition_id || '';
  const gameName = currentGame?.game_name || currentGame?.game_name_cn || '';
  // Studio 场景无 Tab 切换，仅满足情报组件 Props 约束；实际跳转仍由 history.push 处理
  const setActiveId = useCallback(() => undefined, []);

  if (!gameId) {
    return <StudioState />;
  }

  return (
    <div
      className={classNames('dbh-potential-market-mobile', className)}
      style={style}
    >
      <MobileDetailsOverlap
        key={gameId}
        loading={false}
        entityType="mobile"
        setActiveId={setActiveId}
        gameId={gameId}
        gameName={gameName}
      />
    </div>
  );
};

export default MobileOverlapService;
